import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DEFAULT_OFFSET, DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@gnv-shared/constants';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationParam, TableColumn, TableComponent, tableSortEvent, TableSummary } from 'daisy-design-system-front';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription, tap } from 'rxjs';
import { GetChildOfRequest$Params } from '../../../../swagger-gen/web-secured/fn/reporting/get-child-of-request';
import { SearchExportRequestModels$Json$Params } from '../../../../swagger-gen/web-secured/fn/reporting/search-export-request-models-json';
import { ExportRequestsState, selectExportRequestChildrenForm, ExportRequestsChildrenActions } from '../../../store';

@Component({
  selector: "app-export-request-child",
  templateUrl: "./export-request-child.component.html",
  styleUrls: ["./export-request-child.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    TranslateModule,
  ]
})
export class ExportRequestChildComponent implements OnInit, OnDestroy {
  @Input() parentId!: string;
  @Input() tableColumns!: TableColumn[];

  public tableView$: Observable<ExportRequestsState>

  public tableSummary!: TableSummary;
  public loading!: boolean;
  public pagination!: PaginationParam;
  public searchFilter!: GetChildOfRequest$Params;

  private tableViewSub$!: Subscription;

  constructor(
    private readonly store: Store,
    private readonly ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.tableColumns = this.config.data.tableColumns;
    this.parentId = this.config.data.parentId;

    this.tableView$ = this.store.select(selectExportRequestChildrenForm)
    .pipe(
        tap((response: ExportRequestsState) => {
          this.loading = response.loading;

          if (response.loading ===  false && response.hasError === false) {
            this.pagination.totalItems = response.totalItems;
          }
        })
      );
  }

  ngOnInit(): void {
    this.initPagination();

    this.store.dispatch(ExportRequestsChildrenActions.search({filter: this.searchFilter}));

    this.tableViewSub$ = this.tableView$
    .subscribe((response) => {
      this.loading = response.loading;

      if (response.loading === false && response.hasError === false) {
        this.pagination.totalItems = response.totalItems;
      }
    });
  }

  onPageChange(param: PaginationParam) {
    this.pagination = { ...this.pagination, currentPage: param.currentPage, limit: param.limit };

    this.searchFilter = {
      ...this.searchFilter,
      limit: param.limit,
      offset: param.offset,
    };

    this.fetchChildrenByParentId(this.searchFilter);
  }

  onSortChange(event: tableSortEvent) {
    this.pagination = {
      ...this.pagination,
      currentPage: DEFAULT_PAGE
    }

    this.fetchChildrenByParentId({
      uid: this.parentId,
      limit: DEFAULT_PAGE_SIZE,
      offset: DEFAULT_OFFSET,
      sortFieldName: event.fieldId as SearchExportRequestModels$Json$Params["sortFieldName"],
      sortDirection: event.order,
    });
  }

   private fetchChildrenByParentId(filter: GetChildOfRequest$Params) {
      this.store.dispatch(
        ExportRequestsChildrenActions.search({filter})
      );
  }

  private initPagination() {
    this.pagination = {
      currentPage: DEFAULT_PAGE,
      limit: DEFAULT_PAGE_SIZE,
      totalItems: 0,
      offset: DEFAULT_OFFSET,
    };

    this.searchFilter = {
      uid: this.parentId,
      limit: this.pagination.limit,
      offset: this.pagination.offset,
    };
  }

  ngOnDestroy(): void {
    this.tableViewSub$?.unsubscribe();
  }
}
